module.exports = __webpack_public_path__ + "media/images/kip-virtual-gifts-1e9cc0efe4ce27722de7bbfad508c04b.png";